/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-return-assign */
/* eslint-disable react/jsx-props-no-spreading */
import {
    SelectTable,
} from 'appkit-react';
import { useEffect, useRef } from 'react';

import Loader from '../../../Shared/components/Loader';
import '../styles/file-explorer.scss';

const getSizeHeaderProps = () => ({
    className: 'demo-table-small-column',
});

const getSizeProps = () => ({
    className: 'demo-table-small-column',
});

const getNameProps = () => ({
    style: {
        fontWeight: 500,
    },
});

const selectType = 'checkbox';
const keyField = 'id';

const getSpanClassName = data => {
    let style;
    if (data.type === 'directory' && data.name === 'Shared with me') {
        style = 'icon-stewardship-fill';
    } else if (data.type === 'directory') {
        style = 'icon-folder-closed-fill';
    } else {
        style = 'icon-file-fill';
    }
    return style;
};

const FileExplorer = ({
    fileExporerBreadcrumb, fileExplorerDataSource, fileSelectionChangeHandler,
    fetchFolderData, dirDetailsLoading, selection, setSelection, selectAll, setSelectAll,
    isSharedDirectory,
}) => {
    let selectTable = useRef();

    const fileExporerColumns = [
        {
            Header: 'Name',
            accessor: 'name',
            width: 350,
            getProps: getNameProps,
            Cell: ({ original }) => (
                <div className="center-align" style={{ cursor: original.type === 'directory' ? 'pointer' : '' }} onClick={() => fetchFolderData(original)} role="presentation">
                    <span
                        className={
                            `appkiticon ${getSpanClassName(original)} a-text-icon col-icon`
                        }
                        style={{ color: (original.type === 'directory') ? '#ffb600' : '#7d7d7d' }}
                    />
                    <span>{original.name}</span>
                </div>
            ),
        },
        {
            Header: 'Type',
            accessor: 'type',
            width: 150,
            getHeaderProps: getSizeHeaderProps,
            getProps: getSizeProps,
            Cell: ({ original }) => (
                <span>{original.type === 'directory' ? 'Folder' : 'File'}</span>
            ),
        },
        {
            Header: 'Size',
            accessor: 'fileSize',
            width: 180,
            getHeaderProps: getSizeHeaderProps,
            getProps: getSizeProps,
        },
        {
            Header: 'Last modified',
            accessor: 'dateAdded',
        },
        {
            Header: `${isSharedDirectory ? 'Owner' : ''}`,
            accessor: 'owner',
            Cell: ({ value }) => (
                <span>{isSharedDirectory ? value : ''}</span>
            ),
        },
    ];

    useEffect(() => {
        fileSelectionChangeHandler(selection);
    }, [selection]);

    const toggleSelection = key => {
        let tempSelection = [...selection];
        const keyIndex = tempSelection.indexOf(key);
        if (keyIndex >= 0) {
            tempSelection = [
                ...tempSelection.slice(0, keyIndex),
                ...tempSelection.slice(keyIndex + 1),
            ];
        } else {
            tempSelection.push(key);
        }
        setSelection(tempSelection);
    };

    const toggleAll = () => {
        const tempSelectAll = !selectAll;
        const tempSelection = [];
        if (tempSelectAll) {
            const wrappedInstance = selectTable.getWrappedInstance();
            const currentRecords = wrappedInstance.getResolvedState().sortedData;
            currentRecords.forEach(item => {
                if (item._original) {
                    tempSelection.push(item._original.id);
                }
            });
        }
        setSelection(tempSelection);
        setSelectAll(tempSelectAll);
    };

    const isSelected = key => selection.includes(key);

    const extraProps = {
        selectAll,
        isSelected,
        toggleAll,
        toggleSelection,
        selectType,
        keyField,
    };

    return (
        <>
            <div className="files-explorer-demo basic">
                {fileExporerBreadcrumb}

                {dirDetailsLoading && <Loader />}

                {!dirDetailsLoading && (
                    <SelectTable
                        ref={r => (selectTable = r)}
                        striped={false}
                        data={fileExplorerDataSource || []}
                        columns={fileExporerColumns}
                        size="lg"
                        showPagination
                        defaultPageSize={10}
                        defaultSorted={[
                            {
                                id: 'type',
                            },
                        ]}
                        sortable
                        resizable
                        getTrProps={() => ({
                            className: 'a-file-explorer-row-color',
                        })}
                        getTheadProps={() => ({
                            className: 'a-apply-theme-background-gray-level-1',
                        })}
                        {...extraProps}
                    />
                )}
            </div>
        </>
    );
};

export default FileExplorer;
